import type { SaveStorage } from '../saves/storage';

export const SETTINGS_KEY = 'ironvein.settings.v1';

export interface GameSettings {
  masterVolume: number;
  muted: boolean;
  reducedMotion: boolean;
  largeText: boolean;
  highContrast: boolean;
}

export const DEFAULT_SETTINGS: GameSettings = {
  masterVolume: 0.55,
  muted: false,
  reducedMotion: false,
  largeText: false,
  highContrast: false,
};

function isGameSettings(value: unknown): value is GameSettings {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<GameSettings>;
  return typeof candidate.masterVolume === 'number' &&
    candidate.masterVolume >= 0 &&
    candidate.masterVolume <= 1 &&
    typeof candidate.muted === 'boolean' &&
    typeof candidate.reducedMotion === 'boolean' &&
    typeof candidate.largeText === 'boolean' &&
    typeof candidate.highContrast === 'boolean';
}

export function loadSettings(storage?: SaveStorage): GameSettings {
  if (!storage) return { ...DEFAULT_SETTINGS };
  try {
    const raw = storage.getItem(SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed: unknown = JSON.parse(raw);
    return isGameSettings(parsed) ? { ...parsed } : { ...DEFAULT_SETTINGS };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: GameSettings, storage?: SaveStorage): void {
  if (!storage) return;
  storage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}
